import { Config } from "../../../../Config";
import { BufferTargetType } from "../../../RenderEngine/RenderEnum/BufferTargetType";
import { WebGLRenderGeometryElement } from "./WebGLRenderGeometryElement";
import { WebGLBufferState } from "./WebGLBufferState";
import { WebGLIndexBuffer } from "./WebGLIndexBuffer";
import { WebGLShaderInstance } from "./WebGLShaderInstance";
import { WebGLVertexBuffer } from "./WebGLVertexBuffer";
import { LayaGL } from "../../../layagl/LayaGL";
import { WebGLEngine } from "./WebGLEngine";
import { WebGLMode } from "./WebGLEngine/GLEnum/WebGLMode";
import { WebGLCommandUniformMap } from "./WebGLCommandUniformMap";
import { WebGLShaderData } from "../../RenderModuleData/WebModuleData/WebGLShaderData";
import { Laya } from "../../../../Laya";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { ShaderVariantCollection } from "../../../RenderEngine/RenderShader/ShaderVariantCollection";
import { Vector2 } from "../../../maths/Vector2";
export class WebGLGlobalPipeLineCacheInfo {
    constructor() {
        this.globalDefineChangeFlag = new Vector2();
        this.globalDefineData = LayaGL.unitRenderModuleDataFactory.createDefineDatas();
    }
}
export class OneDrawPassCacheInfo {
    constructor() {
        this.matCacheFlag = new Vector2(-1, -1);
        this.nodeCacheFlag = new Vector2(-1, -1);
        this.passDefineCacheFlag = new Vector2(-1, -1);
        this.shaderInss = [];
    }
}
export function compareCahceFlag(changeFlag, cacheFlag) {
    let needUpdate = false;
    if (changeFlag.x > cacheFlag.x)
        needUpdate = true;
    else if (changeFlag.x === cacheFlag.x) {
        needUpdate = changeFlag.y > cacheFlag.y;
    }
    return needUpdate;
}
export function coverCahceFlag(coverFlag, oldFlag) {
    let needUpdate = false;
    if (coverFlag.x > oldFlag.x)
        needUpdate = true;
    else if (coverFlag.x === oldFlag.x) {
        needUpdate = coverFlag.y > oldFlag.y;
    }
    if (needUpdate) {
        coverFlag.cloneTo(oldFlag);
    }
    return;
}
export class WebGLRenderDeviceFactory {
    constructor() {
        this.globalBlockMap = {};
    }
    createShaderData(ownerResource) {
        return new WebGLShaderData(ownerResource);
    }
    createShaderInstance(shaderProcessInfo, shaderPass) {
        let shaderIns = new WebGLShaderInstance();
        shaderIns._create(shaderProcessInfo, shaderPass);
        if (Shader3D.debugMode) {
            let defineString = shaderProcessInfo.defineString;
            let is2D = shaderProcessInfo.is2D;
            ShaderVariantCollection.active.add(shaderPass, defineString, is2D);
        }
        return shaderIns;
    }
    createIndexBuffer(bufferUsageType) {
        return new WebGLIndexBuffer(BufferTargetType.ELEMENT_ARRAY_BUFFER, bufferUsageType);
    }
    createVertexBuffer(bufferUsageType) {
        return new WebGLVertexBuffer(BufferTargetType.ARRAY_BUFFER, bufferUsageType);
    }
    createBufferState() {
        return new WebGLBufferState();
    }
    createRenderGeometryElement(mode, drawType) {
        return new WebGLRenderGeometryElement(mode, drawType);
    }
    createGlobalUniformMap(blockName) {
        let comMap = this.globalBlockMap[blockName];
        if (!comMap)
            comMap = this.globalBlockMap[blockName] = new WebGLCommandUniformMap(blockName);
        return comMap;
    }
    createEngine(config, canvas) {
        let engine;
        let glConfig = { stencil: Config.isStencil, alpha: Config.isAlpha, antialias: Config.isAntialias, premultipliedAlpha: Config.premultipliedAlpha, preserveDrawingBuffer: Config.preserveDrawingBuffer, depth: Config.isDepth, failIfMajorPerformanceCaveat: Config.isfailIfMajorPerformanceCaveat, powerPreference: Config.powerPreference };
        const webglMode = Config.useWebGL2 ? WebGLMode.Auto : WebGLMode.WebGL1;
        engine = new WebGLEngine(glConfig, webglMode);
        engine.initRenderEngine(canvas.source);
        var gl = engine._context;
        if (Config.printWebglOrder)
            this._replaceWebglcall(gl);
        if (gl) {
            new LayaGL();
        }
        LayaGL.renderEngine = engine;
        LayaGL.textureContext = engine.getTextureContext();
        return Promise.resolve();
    }
    _replaceWebglcall(gl) {
        var tempgl = {};
        for (const key in gl) {
            if (typeof gl[key] == "function" && key != "getError" && key != "__SPECTOR_Origin_getError" && key != "__proto__") {
                tempgl[key] = gl[key];
                gl[key] = function () {
                    let arr = [];
                    for (let i = 0; i < arguments.length; i++) {
                        arr.push(arguments[i]);
                    }
                    let result = tempgl[key].apply(gl, arr);
                    let err = gl.getError();
                    if (err) {
                        debugger;
                    }
                    return result;
                };
            }
        }
    }
}
Laya.addBeforeInitCallback(() => {
    if (!LayaGL.renderDeviceFactory)
        LayaGL.renderDeviceFactory = new WebGLRenderDeviceFactory();
});
